// extracted by mini-css-extract-plugin
export var modal = "_iq-0";